/**
 * Originated in project-hsa:
 * HSA/repos/project-hsa/browse/frontend/src/config/index.ts
 */
import { getEnvironment } from './environment';

interface AuthConfig {
  audience: string;
  clientId: string;
  domain: string;
}

export const authConfig = (): AuthConfig => {
  const { environment } = getEnvironment();

  if (environment === 'production' || environment === 'loadtest') {
    return {
      audience: 'https://production-alex-accounts.auth0.com/api/v2/',
      clientId: 'USvn8OJ5t17jN8MDwU0S9vHGRbVtH8Ua',
      domain: 'login.myalex.com',
    };
  }

  if (
    environment === 'sandbox' ||
    environment === 'test' ||
    environment === 'docker' ||
    environment === 'development'
  ) {
    // Test driving a new auth0 tenant for SRE
    return {
      audience: 'https://sandbox-alex-accounts.us.auth0.com/api/v2/',
      clientId: 'bkxmQx8IDGkVCyAngqaVxdusWUh4Qtdt',
      domain: 'sandbox-login.jellydevs.com',
    };
  }

  return {
    audience: 'https://pre-production-alex-accounts.auth0.com/api/v2/',
    clientId: 'L4fECbA80d9OD1j5cLfw3aVssN2qrI6E',
    domain: 'login.jellydevs.com',
  };
};

export default { authConfig };
